export default __webpack_public_path__ + "static/media/android-download-btn.d3e74b27.svg";